var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _path10, _path11, _path12, _path13, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHighLevel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 299,
    height: 119,
    viewBox: "0 0 299 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M298.89 117H-0.89C-0.95 117 -1 116.95 -1 116.89V1C-1 -1.21 0.79 -3 3 -3H294.89C297.16 -3 299 -1.16 299 1.11V116.89C299 116.95 298.95 117 298.89 117Z",
    fill: "url(#paint0_linear_223_28099)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5599 36.8599C41.5599 39.5999 39.3399 41.8199 36.5999 41.8199C33.8599 41.8199 31.6399 39.5999 31.6399 36.8599C31.6399 34.1199 33.8599 31.8999 36.5999 31.8999C39.3399 31.8999 41.5599 34.1199 41.5599 36.8599Z",
    fill: "url(#paint1_linear_223_28099)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M97.99 39.69H49.33C47.76 39.69 46.49 38.42 46.49 36.86C46.49 35.3 47.76 34.02 49.33 34.02H97.99C99.56 34.02 100.83 35.29 100.83 36.86C100.83 38.43 99.56 39.69 97.99 39.69Z",
    fill: "url(#paint2_linear_223_28099)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2801 53.21C41.2801 55.95 39.0601 58.17 36.3201 58.17C33.5801 58.17 31.3601 55.95 31.3601 53.21C31.3601 50.47 33.5801 48.25 36.3201 48.25C39.0601 48.25 41.2801 50.47 41.2801 53.21Z",
    fill: "url(#paint3_linear_223_28099)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7102 56.0499H49.0502C47.4802 56.0499 46.2102 54.7799 46.2102 53.2199C46.2102 51.6599 47.4802 50.3799 49.0502 50.3799H97.7102C99.2802 50.3799 100.55 51.6499 100.55 53.2199C100.55 54.7899 99.2802 56.0499 97.7102 56.0499Z",
    fill: "url(#paint4_linear_223_28099)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M214.73 36.5699C214.73 39.3099 212.51 41.5299 209.77 41.5299C207.03 41.5299 204.81 39.3099 204.81 36.5699C204.81 33.8299 207.03 31.6099 209.77 31.6099C212.51 31.6099 214.73 33.8299 214.73 36.5699Z",
    fill: "url(#paint5_linear_223_28099)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M271.16 39.4H222.5C220.93 39.4 219.66 38.13 219.66 36.57C219.66 35.01 220.93 33.73 222.5 33.73H271.16C272.73 33.73 274 35 274 36.57C274 38.14 272.73 39.4 271.16 39.4Z",
    fill: "url(#paint6_linear_223_28099)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M60.7 78.1102C60.7 71.2502 66.26 65.7002 73.11 65.7002C79.96 65.7002 85.5199 71.2602 85.5199 78.1102C85.5199 84.9602 79.96 90.5202 73.11 90.5202C66.26 90.5202 60.7 84.9602 60.7 78.1102ZM73.1299 81.7902C70.8299 81.7902 68.6599 81.4602 66.7399 80.8702C66.1399 80.6902 65.56 81.2002 65.8 81.7802C67.01 84.6502 69.8299 86.6502 73.1299 86.6502C76.4299 86.6502 79.24 84.6402 80.4599 81.7802C80.6999 81.2102 80.1199 80.6902 79.5199 80.8702C77.5899 81.4602 75.4299 81.7902 73.1299 81.7902ZM69.2399 71.9102C68.3799 71.9102 67.69 73.3002 67.69 75.0102C67.69 76.7202 68.3799 78.1102 69.2399 78.1102C70.0999 78.1102 70.79 76.7202 70.79 75.0102C70.79 73.3002 70.0999 71.9102 69.2399 71.9102ZM77 78.1202C77.86 78.1202 78.55 76.7302 78.55 75.0202C78.55 73.3102 77.86 71.9202 77 71.9202C76.14 71.9202 75.4499 73.3102 75.4499 75.0202C75.4499 76.7302 76.14 78.1202 77 78.1202Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.09 78.5999C148.09 71.7399 153.65 66.1899 160.5 66.1899C167.35 66.1899 172.91 71.7499 172.91 78.5999C172.91 85.4499 167.35 91.0099 160.5 91.0099C153.65 91.0099 148.09 85.4499 148.09 78.5999ZM164.96 85.3199C165.24 85.6399 165.73 85.6799 166.06 85.3999C166.38 85.1199 166.42 84.6299 166.14 84.2999C165.06 83.0599 163.18 81.7099 160.51 81.7099C157.84 81.7099 155.96 83.0599 154.88 84.2999C154.6 84.6199 154.63 85.1099 154.96 85.3999C155.28 85.6799 155.77 85.6499 156.06 85.3199C156.93 84.3199 158.41 83.2599 160.52 83.2599C162.63 83.2599 164.06 84.3199 164.98 85.3199H164.96ZM156.64 74.7199C155.78 74.7199 155.09 75.4099 155.09 76.2699C155.09 77.1299 155.78 77.8199 156.64 77.8199C157.5 77.8199 158.19 77.1299 158.19 76.2699C158.19 75.4099 157.49 74.7199 156.64 74.7199ZM164.4 77.8199C165.25 77.8199 165.95 77.1299 165.95 76.2699C165.95 75.4099 165.25 74.7199 164.4 74.7199C163.55 74.7199 162.85 75.4099 162.85 76.2699C162.85 77.1299 163.54 77.8199 164.4 77.8199Z",
    fill: "white"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M128.28 36.5C128.28 39.24 126.06 41.46 123.32 41.46C120.58 41.46 118.36 39.24 118.36 36.5C118.36 33.76 120.58 31.54 123.32 31.54C126.06 31.54 128.28 33.76 128.28 36.5Z",
    fill: "url(#paint7_linear_223_28099)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M184.71 39.3302H136.05C134.48 39.3302 133.21 38.0602 133.21 36.5002C133.21 34.9402 134.48 33.6602 136.05 33.6602H184.71C186.28 33.6602 187.55 34.9302 187.55 36.5002C187.55 38.0702 186.28 39.3302 184.71 39.3302Z",
    fill: "url(#paint8_linear_223_28099)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M127.99 52.8501C127.99 55.5901 125.77 57.8101 123.03 57.8101C120.29 57.8101 118.07 55.5901 118.07 52.8501C118.07 50.1101 120.29 47.8901 123.03 47.8901C125.77 47.8901 127.99 50.1101 127.99 52.8501Z",
    fill: "url(#paint9_linear_223_28099)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M184.43 55.69H135.77C134.2 55.69 132.93 54.42 132.93 52.86C132.93 51.3 134.2 50.02 135.77 50.02H184.43C186 50.02 187.27 51.29 187.27 52.86C187.27 54.43 186 55.69 184.43 55.69Z",
    fill: "url(#paint10_linear_223_28099)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M234.29 78.7C234.29 71.84 239.85 66.29 246.7 66.29C253.55 66.29 259.11 71.85 259.11 78.7C259.11 85.55 253.55 91.11 246.7 91.11C239.85 91.11 234.29 85.55 234.29 78.7ZM246.72 82.38C244.42 82.38 242.25 82.05 240.33 81.46C239.73 81.28 239.15 81.79 239.39 82.37C240.6 85.24 243.42 87.24 246.72 87.24C250.02 87.24 252.83 85.23 254.05 82.37C254.29 81.8 253.71 81.28 253.11 81.46C251.18 82.05 249.02 82.38 246.72 82.38ZM242.83 72.5C241.97 72.5 241.28 73.89 241.28 75.6C241.28 77.31 241.97 78.7 242.83 78.7C243.69 78.7 244.38 77.31 244.38 75.6C244.38 73.89 243.69 72.5 242.83 72.5ZM250.59 78.71C251.45 78.71 252.14 77.32 252.14 75.61C252.14 73.9 251.45 72.51 250.59 72.51C249.73 72.51 249.04 73.9 249.04 75.61C249.04 77.32 249.73 78.71 250.59 78.71Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_223_28099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299 5.54C298.78 5.51 298.55 5.5 298.32 5.5H12.18C9.05 5.5 6.5 7.94 6.5 10.94V117H7.54V10.94C7.54 8.49 9.62 6.5 12.18 6.5H298.31C298.54 6.5 298.77 6.53 298.99 6.57V5.55L299 5.54Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_223_28099",
    x: 4.5,
    y: 3.5,
    width: 296.5,
    height: 115.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_223_28099"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_223_28099",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_223_28099",
    x1: -1,
    y1: 57,
    x2: 299,
    y2: 57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F96209"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDAE4F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_223_28099",
    x1: 31.6399,
    y1: 36.8599,
    x2: 41.5599,
    y2: 36.8599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_223_28099",
    x1: 46.5,
    y1: 36.86,
    x2: 100.83,
    y2: 36.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_223_28099",
    x1: 31.3601,
    y1: 53.21,
    x2: 41.2801,
    y2: 53.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_223_28099",
    x1: 46.2202,
    y1: 53.2099,
    x2: 100.55,
    y2: 53.2099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_223_28099",
    x1: 204.81,
    y1: 36.5699,
    x2: 214.73,
    y2: 36.5699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_223_28099",
    x1: 219.67,
    y1: 36.56,
    x2: 274,
    y2: 36.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_223_28099",
    x1: 118.36,
    y1: 36.5,
    x2: 128.28,
    y2: 36.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_223_28099",
    x1: 133.22,
    y1: 36.5002,
    x2: 187.55,
    y2: 36.5002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_223_28099",
    x1: 118.07,
    y1: 52.8501,
    x2: 127.99,
    y2: 52.8501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_223_28099",
    x1: 132.94,
    y1: 52.85,
    x2: 187.26,
    y2: 52.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighLevel);
export default __webpack_public_path__ + "static/media/HighLevel.1de46ecb.svg";
export { ForwardRef as ReactComponent };